import { nameRejext } from "./StringRejex";
import { formatDate } from "./getWeekDays";

export const GetAllCharts = async (apiEndPOint, dataRequest) => {
  const title = nameRejext(dataRequest.title);

  let startDate = undefined;

  if (dataRequest.title) {
    const provider = [
      "TIME BAZAR",
      "MADHUR DAY",
      "RAJDHANI DAY",
      "MILAN DAY",
      "KALYAN",
      "SRIDEVI NIGHT",
      "MILAN NIGHT",
      "RAJDHANI NIGHT",
      "MAIN BAZAR",
      "KALYAN NIGHT",
      "SRIDEVI",
      "MADHUR NIGHT",
      "SUPREME DAY",
      "SUPREME NIGHT",
    ];

    if (provider.includes(dataRequest.title)) {
      startDate = "03/23/2026";
    }
  }

  const res = await apiEndPOint({
    id: dataRequest.id,
    name: title,
    startDate: startDate,
  });

  if (res.status) {
    const convertedData = {
      data: [],
    };

    let aa = res.data.sort(
      (a, b) => new Date(a.startDate) - new Date(b.startDate)
    );

    res.data.forEach((weekData) => {
      const week = {
        weekStartDay: formatDate(weekData.startDate),
        weekEndDay: formatDate(weekData.endDate),
        data: [],
      };

      let currentResultDate = "";
      let relatedData = [];

      weekData.data.forEach((item) => {
        if (
          item.resultDate !== currentResultDate &&
          item.winningDigit !== "test" &&
          item.winningDigitFamily !== "test"
        ) {
          if (currentResultDate !== "") {
            week.data.push({
              resultDate: currentResultDate,
              relatedData: relatedData,
            });
          }
          currentResultDate = item.resultDate;
          relatedData = [];
        }

        relatedData.push(item);
      });

      week.data.push({
        resultDate: currentResultDate,
        relatedData: relatedData,
      });

      convertedData.data.push(week);
    });

    return convertedData;
  }
};